/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum FileGridItemMenuKey {
  GENERATE_LINK = 'GENERATE_LINK',
  OPEN_EMAIL = 'OPEN_EMAIL',
  SAVE_LOCAL = 'SAVE_LOCAL',
}
